import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { StickyContainer } from './components/sticky-container';
import type { ISmeStickyTableProps, IStickyTableDeps } from './models';
import { SmeStickyTable as Component } from './sme-sticky-table';

export const SmeStickyTable = createWidget<IStickyTableDeps, ISmeStickyTableProps>({
    StickyContainer,
})(Component);
